import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { User } from './';

@Model()
export default class BillingSession extends ApplicationRecord {
  static jsonapiType = 'billing-sessions';

  static scopeFactory() {
    return BillingSession.includes([]);
  }

  @Attr() url: string;

  @HasOne() user: User;
}
